import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_circle",
  "use": "icon-close_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close_circle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17,7.05A7,7,0,1,0,17,17,7,7,0,0,0,17,7.05Zm-3.18,8.13L12,13.41l-1.77,1.77L8.82,13.77,10.59,12,8.82,10.23l1.41-1.41L12,10.59l1.77-1.77,1.41,1.41L13.41,12l1.77,1.77Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol